import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  analyticsParamsFromState: '',
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setAnalyticsParamsToState: (state, action) => {
      state.analyticsParamsFromState = action.payload; // Store API data
    },
  },
});

export const { setAnalyticsParamsToState } = analyticsSlice.actions;
export default analyticsSlice.reducer;
